<template>
  <div>
    <div
      class="content-item flex align-items-center"
      :class="{ loaded: uploadVideoPicSuccess }"
    >
      <div class="content-item-label">视频封面</div>
      <el-upload
        action="/imageUpload.action"
        :auto-upload="false"
        list-type="picture-card"
        :on-remove="onImgPosterRemove"
        :on-preview="onImgPosterPreview"
        :http-request="httpRequestPoster"
        :on-change="onImgPosterChange"
        :before-upload="checkFile"
        :limit="1"
        :file-list="posterPicUrl"
        accept="image/png, image/jpeg,image/gif"
        ref="fileUploadPoster"
      >
        <div
          class="item-conver flex align-items-center justify-content-center flex-direction-column"
        >
          <img src="~_img/upload.png" alt="图片上传" />
          <span>上传视频封面</span>
        </div>
      </el-upload>
      <!-- 图片预览 -->
      <el-dialog :visible.sync="dialogVisible">
        <img width="100%" :src="dialogImageUrl" alt="" />
      </el-dialog>
    </div>
    <p class="tips">
      视频上传成功后，系统进行转码操作，请等待1-2分钟再上传视频封面
    </p>
    <!-- vueCropper 剪裁图片实现-->
    <el-dialog
      class="cropper-dialog"
      title="图片剪裁"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :before-close="cancel"
      :visible.sync="dialogCropperVisible"
    >
      <div class="cropper-content">
        <div class="cropper" style="text-align: center">
          <vueCropper
            ref="cropper"
            :img="cropperImg"
            :outputSize="1"
            outputType="jpeg"
            :info="true"
            :full="true"
            :canScale="true"
            :canMoveBox="true"
            :original="false"
            :autoCrop="true"
            :fixed="false"
            :centerBox="true"
            :infoTrue="false"
            :fixedBox="false"
            :autoCropWidth="8888"
            :autoCropHeight="8888"
            mode="contain"
          ></vueCropper>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancel">取 消</el-button>
        <el-button type="primary" @click="finish">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
/**
 * "articleVideoInfos": [
    {
      "articleId": 302796,
      "created": "2021-06-07 20:45:47",
      "creator": "jd_ntcUGAAHdoIc",
      "duration": 121,
      "fullImageUrl": "https://jvod.300hu.com/img/2021/81386173/1/img2.jpg",
      "height": 720,
      "id": 5997,
      "imageUrl": "https://jvod.300hu.com/img/2021/81386173/1/img2.jpg",
      "playUrl": "https://jvod.300hu.com/vod/product/73ee10e3-2bbb-490b-b5bc-7268b574e978/f3a9ce3f32c9490f8e1df28da7366dda.mp4",
      "size": 7425591,
      "updated": "2021-06-07 20:45:47",
      "uploadPin": "jd_ntcUGAAHdoIc",
      "uploadServerIp": "10.172.70.67",
      "vid": 578891699,
      "videoCode": 2,
      "videoMarks": "[]",
      "videoName": "1.mp4",
      "width": 1280,
      "yn": 1
    }]
 */
import { uploadFile, request } from "@/utils/axios";
export default {
  name: "uploadPosterImage",
  // props:["posterImage","videoVid"],
  props: ["form", "functionIds"],
  data() {
    return {
      uploadVideoPicSuccess: false,
      dialogVisible: false,
      dialogImageUrl: "",
      dialogCropperVisible: false,
      cropperImg: "",
      imgHost: "//image.healthjd.com/da/",
      posterPicUrl: [],
    };
  },
  watch: {
    "form.articleVideoInfos": {
      handler(val) {
        if (val && val.length) {
          this.uploadVideoPicSuccess = true;
          const imgUrl = val[0].imageUrl || "";
          this.posterPicUrl = [
            {
              name: imgUrl.substring(
                imgUrl.lastIndexOf("/") + 1,
                imgUrl.length
              ),
              url:
                imgUrl.indexOf("http") === 0 ? imgUrl : this.imgHost + imgUrl,
            },
          ];
        } else {
          this.uploadVideoPicSuccess = false;
          this.posterPicUrl = [];
        }
      },
      immediate: true,
    },
  },
  methods: {
    /**
     * @desc 从form表单中获取视频ID，如果还没有上传视频返回null
     * @return video id
     */
    getVid() {
      if (
        this.form.articleVideoInfos &&
        this.form.articleVideoInfos.length > 0
      ) {
        return this.form.articleVideoInfos[0].vid;
      }
      return null;
    },
    onImgPosterRemove(file, fileList) {
      this.posterPicUrl = fileList;
      this.uploadVideoPicSuccess = false;
      this.form.articleVideoInfos[0].imageUrl = "";
    },
    onImgPosterChange(file, fileList) {
      this.cropperImg = file.url;
      this.dialogCropperVisible = true;
    },
    onImgPosterPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    checkFile(file) {
      const isJPG = /image\/(jpeg|png)/.test(file.type);
      const isLt5M = file.size / 1024 / 1024 < 5;
      if (!isJPG) {
        this.$message.error("上传图片只能是jpg、png格式！");
      }
      if (!isLt5M) {
        this.$message.error("上传图片大小不能超过 5MB!");
      }
      let data = window.URL.createObjectURL(new Blob([file]));
      this.fileName = file.name;

      return isJPG && isLt5M;
    },
    httpRequestPoster() {
      if (!this.getVid()) {
        this.$message.error("请上传视频文件");
        this.posterPicUrl = [];
        return;
      }
      let file = this.file;
      this.uploadFile(file, (msg) => {
        request(this.functionIds.setVideoCover, {
          vid: this.getVid(),
          imageUrl: msg,
        })
          .then((res) => {
            this.posterPicUrl = [
              {
                url: this.imgHost + msg,
              },
            ];
            this.form.articleVideoInfos[0].imageUrl = msg;
            this.uploadVideoPicSuccess = true;
          })
          .catch((error) => {
            this.$message.error("视频转码未完成");
            this.uploadVideoPicSuccess = false;
            this.posterPicUrl = [];
            // console.log(error.msg);
          });
      });
    },
    uploadFile(file, callback) {
      uploadFile(file, (event) => {
        let percent = parseInt((event.loaded / event.total) * 100 + "");
        if (percent > 99) {
          percent = 99;
        }
        file.progress = percent;
        file.status = "pending";
        // this.setStoragePropertyByName(storageProperty, uploadImageList);
      })
        .then((res) => {
          const id = res.data[0]["id"];
          if (id === "1") {
            const url = res.data[0]["msg"];
            callback && callback(url);
            file.status = "resolve"; // 是否上传成功，根据是否有url来判断
            this.uploadSuccess = true;
          } else if (id === "0") {
            this.$message.error("图片上传失败");
          }
        })
        .catch((error) => {
          file.status = "reject";
          this.$message.error("图片上传失败");
        });
    },
    // 点击裁剪，这一步是可以拿到处理后的地址
    finish() {
      this.dialogCropperVisible = false;
      this.$refs.cropper.getCropBlob((data) => {
        this.file = data;
        this.$refs.fileUploadPoster.submit();
      });
    },
    cancel() {
      this.dialogCropperVisible = false;
      this.posterPicUrl = [];
    },
  },
};
</script>

<style lang="scss" scoped>
.dialog-footer {
  & > button {
    padding-top: 10px;
  }
}
:deep(.el-upload--picture-card) {
  background-color: transparent;
  border: none;
  line-height: normal;
}
:deep(.el-upload-list__item) {
  width: 230px !important;
  height: 150px !important;
  border: 1px solid rgba(0, 0, 0, 0.15) !important;
  border-radius: 4px;
}
:deep(.el-upload-list__item-status-label) {
  display: none !important;
}
.cropper-dialog {
  :deep(.el-dialog) {
    width: 490px;
  }
  .cropper-content {
    width: 100%;
    .cropper {
      width: 100%;
      height: 500px;
    }
  }
}
.item-conver {
  width: 230px;
  height: 150px;
  border: 1px solid rgba(0, 0, 0, 0.15);
  border-radius: 4px;
  font-size: 12px;
  color: #989ca5;
  img {
    margin-bottom: 8px;
  }
}
</style>
